import { GenericBackendResponse } from '../genericBackendResponse';
import { PensionPlanTransfer } from './interfaces/PensionPlanTransfer';

export interface UpdateMyTransferPayload {
	amount?: string;
	originPayload?: Record<string, any>;
	metadata?: Record<string, any>;
	DGSFP_code?: string;
	selectedArcaPlanId?: string;
}

interface UpdateTransferResponse {
	transfer: PensionPlanTransfer;
	message: string;
}

const updateMyTransfer = async (
	token: string,
	transferId: string,
	payload: UpdateMyTransferPayload
): Promise<GenericBackendResponse<UpdateTransferResponse>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/pension-plan-transfers/my-transfers/${transferId}`,
		{
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(payload)
		}
	);

	if (!response.ok) {
		throw new Error(`Update transfer request failed: ${response.status}`);
	}

	return response.json();
};

export default updateMyTransfer;
